import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { TooltipModule } from "../../utils";
import { CheckboxGroupComponent } from "./checkbox-group.component";
import { CheckboxToggleComponent } from "./checkbox-toggle.component";
import { CheckboxComponent } from "./checkbox.component";

const DIRECTIVES = [
  CheckboxComponent,
  CheckboxGroupComponent,
  CheckboxToggleComponent
];

@NgModule({
  imports: [FormsModule, TooltipModule],
  declarations: DIRECTIVES,
  exports: DIRECTIVES
})
export class CheckboxModule {}
